import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

// Register the application's routes configuration.
angular.module('flowingly.runner.setup').config(config);

// Inject the dependencies.
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider
    .state(STATE_MAPPINGS.setupdatabases, {
      url: '/databases',
      params: { flowId: null, title: 'Setup - Databases' },
      views: {
        childcontent: {
          controllerAs: '$ctrl',
          controller: [
            '$state',
            'permissionsService',
            'setupApiService',
            function ($state, permissionsService, setupApiService) {
              if (
                !permissionsService.currentUserHasPermission(
                  FlowinglyPermissions.SETUP_DATABASE_ACCESS
                )
              ) {
                $state.go(STATE_MAPPINGS.flowsactive);
              }

              this.databases = setupApiService.service.databases;
            }
          ],
          template: `<flow-databases databases="$ctrl.databases"></flow-databases>`,
          resolve: {
            databaseAccess: getDatabaseAccessResolve(),
            databases: [
              'databaseAccess',
              'setupApiService',
              function (databaseAccess, setupApiService) {
                return setupApiService.getDatabases();
              }
            ]
          }
        }
      }
    })
    .state(STATE_MAPPINGS.createDatabase, {
      url: 'create-database',
      params: { title: 'Setup - Create Database' },
      resolve: {
        databaseAccess: getDatabaseAccessResolve()
      },
      controller: 'runnerSetupCreateDatabaseController',
      controllerAs: '$ctrl',
      templateUrl:
        'Client/runner.setup/runner.setup.databases/runner.setup.create-database.tmpl.html'
    })
    .state(STATE_MAPPINGS.editDatabase, {
      url: 'edit-database/{physicalTableName}',
      params: { title: 'Setup - Edit Database', dbName: null },
      resolve: {
        databaseAccess: getDatabaseAccessResolve()
      },
      controller: 'runnerSetupEditDatabaseController',
      controllerAs: '$ctrl',
      templateUrl:
        'Client/runner.setup/runner.setup.databases/runner.setup.edit-database.tmpl.html'
    });
}

function getDatabaseAccessResolve() {
  return [
    '$q',
    '$state',
    'APP_CONFIG',
    'permissionsService',
    function ($q, $state, APP_CONFIG, permissionsService) {
      const hasDatabaseAccess = permissionsService.currentUserHasPermission(
        FlowinglyPermissions.SETUP_DATABASE_ACCESS
      );

      if (APP_CONFIG.enableDatabaseFeature && hasDatabaseAccess) {
        return true;
      }

      $state.go(STATE_MAPPINGS.flowsactive);
      return $q.reject();
    }
  ];
}
